import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import React from "react";
interface TestProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: TextState;
    settings: any;
}

export class ReactText extends React.Component<TestProps, any>{
    private inputStyle: React.CSSProperties = {
        border: "1px solid #ccc",
        display: "block",
        width: "100%",
        boxSizing: "border-box",
        height: "34px"
    }
    constructor(props) {
        super(props);
        this.state = { text: this.props.values[this.props.settings.name] };
    }

    handleChange = (event) => {
        this.setState({ text: event.target.value });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ text: this.props.values[this.props.settings.name] });
    }

    handleBlur = (event) => {
        this.props.onTextChange(this.props.settings.name, event.target.value);
    }

    render() {
        var classString = 'form-group';
        return (
            <react_components.ReactColumn width={this.props.metadataSettings.width}>
                <div className={classString}>
                    <label>{this.props.settings.label}</label>
                    <input type="text" value={this.state.text} style={this.inputStyle} onChange={this.handleChange} onBlur={this.handleBlur} />
                </div>
            </react_components.ReactColumn>);
    }
};

export class TextState extends propertyTypes.BaseComponentProps {
    private labelMetadata = new propertyTypes.TranslatableTextProperty("label", "Label");
    public label: string;

    private isMandatoryMetadata = new propertyTypes.CheckBoxProperty("isMandatory", "Is mandatory?");
    public isMandatory: string;

    private checkBoxMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.getNameMetadata().SetMandatory(true);
        const baseMetaData = super.getMetadata();
        this.checkBoxMetadata = baseMetaData.concat([this.labelMetadata, this.isMandatoryMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.checkBoxMetadata;
    }
}